/**
 * Lodash Service
 * Register Lodash as Angular Services
 *
 * @package:  Betta
 * @version:  2.2
 * @author:   Cyrill N KALITA
 * @return    Factory
 */

angular.module('flsServices').factory('_', ['$window', function($window){
    return $window._;
}]);
